import HBConfirm from "../HBModal/confirm";

export function openAiPublishConfirm() {
  return new Promise((resolve) => {
    HBConfirm.open({
      title: "提示",
      content:
        "当前发布内容包含使用AI生成的内容，按照国家法规要求，平台会添加「AI生成」提示",
      okText: "继续发布",
      cancelText: "取消发布",
      onOk: () => {
        resolve(true);
      },
      onCancel: () => {
        resolve(false);
      },
    });
  });
}
